import React, { useState } from "react";
import { useUser } from "../context/UserContext";
import { useNavigate } from "react-router-dom";
import "../css/Login.css";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useLoading } from "../context/LoadingContext";

const Login = () => {
  const { login } = useUser();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const { setIsLoading } = useLoading();

  const handleListarRestaurantes = () => {
    navigate(`/restaurantes`);
  };
  const handleLogin = async (e) => {
    e.preventDefault();
    setError(""); // Limpa mensagens de erro anteriores
    const toastId = toast.loading("Autenticando...");
    setIsLoading(true);
    try {
      await login({ email: username, senha: password });
      toast.update(toastId, {
        render: "Login bem-sucedido!",
        type: "success",
        isLoading: false,
        autoClose: 2000,
      });
      navigate("/restaurantes");
    } catch (err) {
      console.error("Erro ao efetuar login:", err);
      setError("Usuário ou senha inválidos!");
      toast.update(toastId, {
        render: "Usuário ou senha inválidos!",
        type: "error",
        isLoading: false,
        autoClose: 3000,
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-container">
      <ToastContainer />
      <form className="login-form" onSubmit={handleLogin}>
        <h2>Bem-vindo!</h2>
        <p className="login-subtitle">Por favor, faça o login para continuar.</p>
        <input
          type="text"
          placeholder="Usuário"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          required
        />
        <input
          type="password"
          placeholder="Senha"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <button type="submit">Entrar</button>
        {error && (
          <p className="login-error">
            <i className="fa fa-exclamation-circle"></i> {/* Ícone de alerta */}
            {error}
          </p>
        )}
      </form>
      <div className="login-form-alone">
        <button className="login-button-skip" onClick={() => handleListarRestaurantes()}>
            Acessar restaurantes sem login
        </button>
      </div>    
      <div className="login-form-alone">
        <button className="login-button-skip" onClick={() => window.open('https://wa.me/5511948214839?text=Olá, eu estou interessado em cadastrar meu restaurante e começar a usar o genius menu.', '_blank')}>
            Cadastrar meu restaurante
        </button>
      </div>
    </div>
  );
};

export default Login;